<template>

    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <page-title :title="$t('options.editOption')"></page-title>
    </div>

    <jet-form-section @submitted="updateSet()">

        <template #form>

            <form-card :title="$t('set.set')" :description="$t('set.setDescription')">

                <div class="col-span-6">
                    <label for="name" class="block text-sm font-medium text-gray-700">{{ $t("set.name") }} <RequiredMark /></label>
                    <input type="text" name="name" id="name" v-model="form.updateBase.name"
                           class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300"
                           autofocus />
                    <jet-input-error :message="form.errors['updateBase.name']" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label for="title" class="block text-sm font-medium text-gray-700">{{ $t("set.title") }} <RequiredMark /></label>
                    <input type="text" name="title" id="title" v-model="form.updateBase.title"
                           class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300" />
                    <jet-input-error :message="form.errors['updateBase.title']" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label for="description"
                           class="block text-sm font-medium text-gray-700">{{ $t("set.description") }}</label>

                    <textarea type="text" name="reason" id="description"
                              v-model="form.updateBase.description"
                              class="focus:ring-minplan-blue focus:border-minplan-blue w-full mt-3"
                              autofocus></textarea>
                    <jet-input-error :message="form.errors['updateBase.description']" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label for="internal_note"
                           class="block text-sm font-medium text-gray-700">{{ $t("set.internal_note") }}</label>

                    <textarea type="text" name="reason" id="internal_note"
                              v-model="form.updateBase.internal_note"
                              class="focus:ring-minplan-blue focus:border-minplan-blue w-full mt-3"
                              autofocus></textarea>
                    <jet-input-error :message="form.errors['updateBase.internal_note']" class="mt-2" />
                </div>

            </form-card>

        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">

                <button @click="cancel" type="button"
                        class="inline-block uppercase font-semibold text-xs tracking-widest">
                    {{ $t("actions.cancel") }}
                </button>

                <primary-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="ml-3 ">
                    {{ $t("actions.save") }}
                </primary-button>

            </div>
        </template>

    </jet-form-section>

</template>


<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm } from "@inertiajs/inertia-vue3";
import FormCard from "@/Shared/Components/FormCard";
import RadioList from "@/Shared/Components/RadioList";
import RequiredMark from "@/Shared/Components/RequiredMark";

export default defineComponent({
    props: ["set"],
    inheritAttrs: false,
    layout: MainLayout,
    emits: ["closeModal"],
    components: {
        PageTitle,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        FormCard,
        RadioList,
        RequiredMark
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        updateSet() {
            this.form.put(this.route("advisors.option-sets.update", { optionSet: this.set.uuid }), {
                preserveScroll: true,
                preserveState: false,
                onSuccess: () => this.$notify({
                    group: "success",
                    title: "actions.success",
                    text: "options.updated"
                })
            });
        }
    },
    data() {
        return {
            form: useForm({
                updateBase: {
                    name: this.set.name,
                    title: this.set.title,
                    description: this.set.description,
                    internal_note: this.set.internal_note
                }
            })
        };
    }
});
</script>

<style scoped></style>
